const accountManageTabs = [
  {
    label: 'PRODUCTS',
    link: '/settings/app-integration-account-settings/:id/manage/products',
    setting: 'get_products', // Assuming 'get_products' is the setting key
  },
  {
    label: 'COMPANIES',
    link: '/settings/app-integration-account-settings/:id/manage/companies',
    setting: 'sync_client_company', // Assuming 'sync_client_company' is the setting key
  },
  // TODO: Comment for now, uncomment when we have the following pages:
  // {
  //   label: 'SKUS',
  //   link: '/settings/app-integration-account-settings/:id/manage/skus',
  // },
  // {
  //   label: 'KITS',
  //   link: '/settings/app-integration-account-settings/:id/manage/kits',
  // },
];

export const AppIntegrationAccountConfig = {
  accountManageTabs,
};
